export default __webpack_public_path__ + "static/media/appoinments.595f9808.svg";